module.exports = __webpack_public_path__ + "d17676f2b420b6de39be275c2427b99f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/adventure-tube-yellow-s.png
// module id = 1839
// module chunks = 0